import * as LabelPrimitive from "@radix-ui/react-label"
import { Label } from "@/components/atoms/Label/label"
import { useFormField } from "@/hooks/useFormField"
import React from "react"
import { cn } from '@/utils/index'

export const FormLabel = React.forwardRef<
  React.ElementRef<typeof LabelPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof LabelPrimitive.Root>
>(({ className, ...props }, ref) => {
  const { error, formItemId } = useFormField()

  return (
    <Label
      ref={ref}
      className={cn(error && "text-destructive dark:text-neutral-400", className)}
      htmlFor={formItemId}
      {...props}
    />
  )
})
FormLabel.displayName = "FormLabel"
